import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DragDropContext } from 'react-beautiful-dnd';

export const Wrapper = styled(DragDropContext)``;

export const List = styled(Box)`
  flex-direction: column;
  padding: 0;
`;

export const Item = styled(Stack)`
  padding: ${(p) => p.theme.spacing(0.5)} 0;
`;
